"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _RetailBuySell = require("../../../components/Retail/RetailBuySell");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _RecentActivityContainer = _interopRequireDefault(require("../../../components/RecentActivity/RecentActivityContainer"));
require("./BuySellDesktopLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var classes = (0, _cssClassesHelper.getBEMClasses)('buy-sell-alt-layout');
var BuySellDesktopLayout = function BuySellDesktopLayout() {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('layout-header')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('content-wrapper')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('col', ['lg'])
  }, /*#__PURE__*/_react["default"].createElement(_RetailBuySell.BuySellInstrumentSelectContainer, null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('col', ['sm', 'with-padding'])
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('balances-title')
  }, t('Balances')), /*#__PURE__*/_react["default"].createElement(_RetailBuySell.BuySellBalancesContainer, {
    customClass: "compacted"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('col', ['lg', 'with-bottom-padding'])
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container-with-shadow ".concat(classes('chart-overview-container'))
  }, /*#__PURE__*/_react["default"].createElement(_RetailBuySell.BuySellChartOverviewAltContainer, null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('col', ['sm', 'with-padding'])
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('make-transaction-container container-with-shadow', 'alt-layout')
  }, /*#__PURE__*/_react["default"].createElement(_RetailBuySell.BuySellMakeTransactionContainer, {
    themeModifier: "alt-layout"
  }, /*#__PURE__*/_react["default"].createElement(_RetailBuySell.BuySellContainer, {
    themeModifier: "alt-layout",
    displayInstrumentSelector: false,
    extraInfoComponent: /*#__PURE__*/_react["default"].createElement(_RetailBuySell.BuySellOrderOverviewContainer, {
      customClass: "compacted"
    })
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('single-col')
  }, /*#__PURE__*/_react["default"].createElement(_RecentActivityContainer["default"], {
    filterForSelected: false,
    useAdvancedVersion: false,
    headerText: "Recent Orders"
  }))));
};
var _default = exports["default"] = BuySellDesktopLayout;